<script setup lang="ts">
import {defineProps} from "vue";
import {IonButton} from "@ionic/vue";
import Modal from "@/components/Modal.vue";
import BookingSuggestionList from "@/views/Chat/BookingSuggestionList.vue";

export type BookingSuggestionParams = number[] | undefined

const props = defineProps<{
    employeeIds?: number[]
}>()

const isOpen = defineModel<boolean>({default: false})
</script>

<template>
    <Modal v-model="isOpen" title="Dienstvorschläge">
        <BookingSuggestionList
            :employee-ids="props.employeeIds"
            :active="isOpen"
        />
        <template #actions="{dismiss}">
            <IonButton color="primary" @click="dismiss">Zurück</IonButton>
        </template>
    </Modal>
</template>
